import React from "react";
import UpdateTemperature from "./UpdateTemperature";
import FormatDate from "./FormatDate";

import WeatherIcon from "./WeatherIcon";

export default function Weather(props) {
  return (
    <div>
      <h1 className="pt-5 pb-3 text-uppercase fs-1 ms-3">
        {props.data.cityName}
      </h1>
      <div className="row pt-3 pb-5">
        <div className="col-2 temperature position-relative top-0">
          <WeatherIcon code={props.data.iconCode} />
        </div>
        <div className="col-4 temperature">
          <UpdateTemperature celsius={props.data.temperature} />
        </div>
        <div className="col-3">
          Humidity:{" "}
          <span className="fw-bold">
            <span id="humidity-value">{props.data.humidity}</span>%
          </span>
          <br />
          Wind:{" "}
          <span className="fw-bold">
            <span id="wind-value">{props.data.wind}</span> km/h
          </span>
        </div>
        <div className="col-3 fw-bold">
          <FormatDate date={props.data.dt} />
          <span className="fst-italic">{props.data.description}</span>
        </div>
      </div>
    </div>
  );
}
